module.exports = __webpack_public_path__ + "media/images/about/ac_9-2094cab5d2ffb59cd039ab8b1913f998.jpg";